export const ADD_TO_COLLECTION_MODAL = 'addToCollectionModal';
export const CREATE_NEW_COLLECTION_MODAL = 'createNewCollectionModal';
export const EDIT_COLLECTION_MODAL = 'editCollectionModal';
export const SHARE_COLLECTION_MODAL = 'sharedCollectionModal';
export const DELETE_COLLECTION_MODAL = 'deleteCollectionModal';
export const ADD_FROM_FAVOURITE_MODAL = 'addFromFavouriteModal';
export const RENAME_COLLECTION_MODAL = 'renameCollectionModal';
export const ADD_TO_CART_MODAL = 'addToCartModal';

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
export const SET_COLLECTIONS_LOADING = 'SET_COLLECTIONS_LOADING';

export const GET_COLLECTIONS_SUCCESS = 'GET_COLLECTIONS_SUCCESS';

export const ADD_TO_COLLECTION_SUCCESS = 'ADD_TO_COLLECTION_SUCCESS';

export const CREATE_COLLECTION_SUCCESS = 'CREATE_COLLECTION_SUCCESS';

export const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS';

export const DELETE_MULTIPLE_COLLECTION_SUCCESS = 'DELETE_MULTIPLE_COLLECTION_SUCCESS';

export const SET_CURRENT_COLLECTION = 'SET_CURRENT_COLLECTION';

export const SET_CURRENT_VARIANT_IDS = 'SET_CURRENT_VARIANT_IDS';

export const SET_TOAST_ID = 'SET_TOAST_ID';

export const SET_SORTING_OPTION = 'SET_SORTING_OPTION';

export const SET_SELECTED_FILTER_OPTION = 'SET_SELECTED_FILTER_OPTION';

export const GET_SHARED_COLLECTIONS_ERROR = 'GET_SHARED_COLLECTIONS_ERROR';
export const GET_SHARED_COLLECTIONS_PENDING = 'GET_SHARED_COLLECTIONS_PENDING';
export const GET_SHARED_COLLECTIONS_SUCCESS = 'GET_SHARED_COLLECTIONS_SUCCESS';

export const SHOW_COLLECTION_ITEMS = 'SHOW_COLLECTION_ITEMS';

export const GET_COLLECTION_ITEMS_SUCCESS = 'GET_COLLECTION_ITEMS_SUCCESS';

export const DELETE_COLLECTION_ITEMS_SUCCESS = 'DELETE_COLLECTION_ITEMS_SUCCESS';

export const DELETE_MULTIPLE_COLLECTION_ITEMS_SUCCESS = 'DELETE_MULTIPLE_COLLECTION_ITEMS_SUCCESS';

export const RENAME_COLLECTION_SUCCESS = 'RENAME_COLLECTION_SUCCESS';

export const ADD_ALL_TO_CART_SUCCESS = 'ADD_ALL_TO_CART_SUCCESS';

export const GET_COLLECTION_ITEMS_FILTERS_OPTIONS = 'GET_COLLECTION_ITEMS_FILTERS_OPTIONS';

export const GET_FAVORITES_SUCCESS = 'GET_FAVORITES_SUCCESS';

export const LIMIT = 6;
export const CARD_COUNT = 3;

export const GA_FROM_FAVOURITES = 'From favourites';
export const GA_FROM_PDP = 'From PDP';
export const GA_SHARED_COLLECTION = 'From another collection';
export const GA_COPY_SHARED_URL = 'Copy shared url';

export const DATE_DESC = 'date_desc';
export const DATE_ASC = 'date_asc';
export const PRICE_DESC = 'price_desc';
export const PRICE_ASC = 'price_asc';
export const NAME_DESC = 'name_desc';
export const NAME_ASC = 'name_asc';
export const SALE_ASC = 'sale_asc';

export const COLLECTION_CACHE_NAME = 'state.collections';
export const COLLECTION_SESSION_NAME = 'collection.session';
